export const nxVersion = require('../../package.json').version;
export const viteVersion = '^5.0.0';
export const vitestVersion = '^1.3.1';
export const vitePluginReactVersion = '^4.2.0';
export const vitePluginReactSwcVersion = '^3.5.0';
export const jsdomVersion = '~22.1.0';
export const vitePluginDtsVersion = '~3.8.1';
export const happyDomVersion = '~9.20.3';
export const edgeRuntimeVmVersion = '~3.0.2';

// Coverage providers
export const vitestCoverageV8Version = '^1.0.4';
export const vitestCoverageIstanbulVersion = '^1.0.4';
